import { mapState } from 'vuex'

import Preloader from '@/components/preloader/preloader.vue'
import ExitPopup from '@/components/exitPopup/exitPopup.vue'

export default {
  components: {
    appPreloader: Preloader,
    appExitPopup: ExitPopup
  },
  computed: {
    ...mapState('tours', ['ready', 'settings', 'title'])
  },
  metaInfo () {
    return {
      title: this.title,
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  }
}
